<div>
  <div class="modal-header">
    <h5 class="title f-16" id="defaultModalLabel">
      <div *ngIf="loadingApi" class="loader loader--style1" title="0">
        <loading-button [loading]="loadingApi"></loading-button>
      </div>
      {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.LC' | translate }} {{ datasourceTypeLabel[datasourceType] }}
    </h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="datasourceFormControl">
      <input *ngIf="isEdit" type="hidden" class="form-control" formControlName="key" />
      <input type="hidden" class="form-control" formControlName="c_type" />

      <ng-container *ngIf="!['hdfs', 'aws', 'bigquery'].includes(datasourceType)">
        <!-- Connection Name -->
        <div class="row clearfix" >
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.CN' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow1" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="name" [readonly]="isEdit" formControlName="c_name" />
                <div
                  *ngIf="
                    datasourceFormControl.controls['c_name'].touched &&
                    datasourceFormControl.controls['c_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.CN_V' | translate }}
                  </p>
                </div>
                <div
                  *ngIf="
                    datasourceFormControl.controls['c_name'].touched &&
                    datasourceFormControl.controls['c_name'].errors?.specialCharacters
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.CNS_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Host & Port -->
        <div class="row clearfix">
          <div class="col-md-6 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.H' | translate }}</label>
          </div>
          <div class="col-md-6 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.PORT' | translate }}</label>
          </div>
        </div>
        <div id="functionList2">
          <div id="functionListRow1" class="row clearfix">
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="host" formControlName="host" />
                <div
                  *ngIf="
                    datasourceFormControl.controls['host'].touched &&
                    datasourceFormControl.controls['host'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.H_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="number" class="form-control" placeholder="port" formControlName="port" />
                <div
                  *ngIf="
                    datasourceFormControl.controls['port'].touched &&
                    datasourceFormControl.controls['port'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.PORT_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Username & Password -->
        <div class="row clearfix">
          <div class="col-md-6 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.U' | translate }}</label>
          </div>
          <div class="col-md-6 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.P' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="username" formControlName="username" />
                <div
                  *ngIf="
                    datasourceFormControl.controls['username'].touched &&
                    datasourceFormControl.controls['username'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.U_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="password" class="form-control" placeholder="password" formControlName="password" />
                <div
                  *ngIf="
                    datasourceFormControl.controls['password'].touched &&
                    datasourceFormControl.controls['password'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.P_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


      <!-- MYSQL, MSSQL, postgresql, DB2, teradata -->
      <!-- Database Name -->
      <div class="row clearfix" *ngIf="['clickhouse', 'mysql', 'mssql', 'postgresql', 'db2', 'teradata', 'cockroachdb'].includes(datasourceType)">
        <div class="col-md-12 form-control-label">
          <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.DB' | translate }}</label>
        </div>
      </div>
      <div id="functionList" *ngIf="['clickhouse', 'mysql', 'mssql', 'postgresql', 'db2', 'teradata', 'cockroachdb'].includes(datasourceType)">
        <div id="functionListRow3" class="row clearfix">
          <div class="col-md-12">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="database" formControlName="database" />
            </div>
          </div>
        </div>
      </div>

      <!-- MSSQL -->
      <!-- Instance -->
      <ng-container *ngIf="datasourceType === 'mssql'">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.I' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="instance" formControlName="instance" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ORACLE -->
      <!-- SID -->
      <ng-container *ngIf="datasourceType === 'oracle'">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.SID' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="SID" formControlName="sid" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- HADOOP ONLY -->
      <ng-container *ngIf="datasourceType === 'hdfs'">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.CN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Type connection name"
                  formControlName="connection_name"
                  [ngClass]="
                    datasourceFormControl.controls['connection_name'].touched &&
                    datasourceFormControl.controls['connection_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['connection_name'].touched &&
                    datasourceFormControl.controls['connection_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.CN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.NN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Type node name"
                  formControlName="node_name"
                  [ngClass]="
                    datasourceFormControl.controls['node_name'].touched &&
                    datasourceFormControl.controls['node_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['node_name'].touched &&
                    datasourceFormControl.controls['node_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.NN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label
              >{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.PORT' | translate }}<font color="red"> *</font></label
            >
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  placeholder="Type port"
                  formControlName="port"
                  [ngClass]="
                    datasourceFormControl.controls['port'].touched &&
                    datasourceFormControl.controls['port'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['port'].touched &&
                    datasourceFormControl.controls['port'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.PORT_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.HDFS_CONN.TOKEN' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Type token" formControlName="token_string" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- MYSQL, postgresql, DB2 -->
      <!-- Query Strings -->
      <ng-container *ngIf="['clickhouse', 'mysql', 'postgresql', 'db2', 'oracle', 'mssql', 'teradata', 'cockroachdb', 'saphana'].includes(datasourceType)">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.QS' | translate }}</label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow1" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <button
                  (click)="openModalQueryString()"
                  class="btn btn-info btn-outline btn-icon btn-lg btn-outline-mini w-100"
                  type="button"
                >
                  {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.AQS' | translate }}
                  <i class="zmdi zmdi-plus f-12 ml-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- AWS ONLY -->
      <ng-container *ngIf="datasourceType === 'aws'">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.CN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Type connection name"
                  formControlName="connection_name"
                  [ngClass]="
                    datasourceFormControl.controls['connection_name'].touched &&
                    datasourceFormControl.controls['connection_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['connection_name'].touched &&
                    datasourceFormControl.controls['connection_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.CN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.BN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="input Bucket Name"
                  formControlName="bucket_name"
                  [ngClass]="
                    datasourceFormControl.controls['bucket_name'].touched &&
                    datasourceFormControl.controls['bucket_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['bucket_name'].touched &&
                    datasourceFormControl.controls['bucket_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.BN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.RN' | translate }}</label>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Input Region Name"
                formControlName="region_name"
              />
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.ACK' | translate }}</label>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Input Access Key ID"
                formControlName="access_key_id"
              />
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.AWS_CONN.SAK' | translate }}</label>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Input Secret Access Key"
                formControlName="secret_access_key"
              />
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Google Big Query ONLY -->
      <ng-container *ngIf="datasourceType === 'bigquery'">
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.CN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Type connection name"
                  formControlName="c_name"
                  [ngClass]="
                    datasourceFormControl.controls['c_name'].touched &&
                    datasourceFormControl.controls['c_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['c_name'].touched &&
                    datasourceFormControl.controls['c_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.CN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.PI' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Input Project ID"
                  formControlName="project_id"
                  [ngClass]="
                    datasourceFormControl.controls['project_id'].touched &&
                    datasourceFormControl.controls['project_id'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['project_id'].touched &&
                    datasourceFormControl.controls['project_id'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.PI_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label>{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.DN' | translate }}<font color="red"> *</font></label>
          </div>
        </div>
        <div id="functionList">
          <div id="functionListRow3" class="row clearfix">
            <div class="col-md-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Input Dataset Name"
                  formControlName="dataset_name"
                  [ngClass]="
                    datasourceFormControl.controls['dataset_name'].touched &&
                    datasourceFormControl.controls['dataset_name'].errors?.required
                      ? 'require-error is-invalid'
                      : ''
                  "
                />
                <div
                  *ngIf="
                    datasourceFormControl.controls['dataset_name'].touched &&
                    datasourceFormControl.controls['dataset_name'].errors?.required
                  "
                >
                  <p class="text-danger" style="font-size: 11px">
                    {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.DN_V' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 form-control-label">
            <label class="mr-2">
              {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.KF' | translate }}<font color="red"> *</font>
            </label>
            <i
              class="zmdi zmdi-info"
              matTooltip="{{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.KF_I' | translate }}"
            ></i>
          </div>
        </div>
        <div class="form-control" style="display: flex;">
          <div class="col-md-2">
            <input type="file" accept=".json" #file_upload (change)="handlerOnChangeInputFile($event)"
              [ngStyle]="{ display: 'none' }" />
            <button class="btn btn-neutral btn-simple btn-md" type="button" (click)="file_upload.click()">
              {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.CF' | translate }}
            </button>
          </div>
          <div class="col-md-10 my-auto" *ngIf="fileUpload.length">
            {{ fileUpload[0].fileName }}
          </div>
        </div>
        <!-- <div *ngIf="
          datasourceFormControl.controls['key_file'].touched &&
          datasourceFormControl.controls['key_file'].errors?.required
        ">
          <p class="text-danger" style="font-size: 11px">
            {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.GBQ_CONN.KF_V' | translate }}
          </p>
        </div> -->
      </ng-container>
    </form>

    <button
      (click)="handleDatasourceConnectionTest()"
      class="btn btn-info btn-outline btn-icon btn-lg btn-outline-mini w-100"
      type="button"
    >
      <loading-button [loading]="loadingTestConn"></loading-button>
      {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.DB_CONN.TC' | translate }}
      <i class="zmdi zmdi-input-power ml-2"></i>
    </button>
  </div>

  <div class="modal-footer">
    <button class="btn btn-info btn-outline btn-sm close" type="button" data-dismiss="modal" (click)="close()">
      {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.C' | translate }}
    </button>
    <button
      *ngIf="!['hdfs', 'aws'].includes(datasourceType)"
      class="btn btn-neutral btn-simple btn-sm"
      type="button"
      (click)="handleDatasourceConnectionSave()"
    >
      {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.S' | translate }}
    </button>
    <button
      *ngIf="['hdfs', 'aws'].includes(datasourceType)"
      class="btn btn-info btn-outline btn-sm"
      type="button"
      (click)="handleConnectionSave(datasourceType)"
    >
      {{ 'MODULE.DATA_PROCESSING.COMMON.MODAL.S' | translate }}
    </button>
  </div>
</div>
